import { createFileRoute } from '@tanstack/react-router';
import SMSConsentDetailsPage from '../views/consent/sms/details';

export const Route = createFileRoute('/consent/sms/details')({
  component: SMSConsentDetailsPage,
});
